export const isDeployedToProduction = window.location.hostname === 'admin.quick.md'
